
let paymentView = require('./paymentView');
let ajaxWrapper = require('./ajaxWrapper');
let tempCardPay = require('./tempCardPay');

let redirectToDashboard = (location) => {
    window.location.replace(location);
};

let initialize = () => {
    paymentView.onLoad(configure);
};

let configure = () => {
    tempCardPay.initialize(ajaxWrapper, redirectToDashboard, paymentView.webUrl(), paymentView);
};

module.exports = {
    initialize: initialize
};
